import { useSelector } from "react-redux";
import { getEnumsFromState, getSelectedCountry } from "../states/slices/resourceSlice";
import { IEnum } from "../resources/interfaces";
import { removeUnderscoresAndCapitalize } from "../utils/miscFunctions";

function useLeads() {
  const enums = useSelector(getEnumsFromState)

  function getLeadSourceFilters() {
    const sources = enums?.leadSources?.map((item: IEnum) => ({
      name: removeUnderscoresAndCapitalize(item.title),
      value: item.key
    }))

    return sources;
  }

  return {
    getLeadSourceFilters,
  };
}

export default useLeads;
